import { useEffect, useState } from "react";

export default function useHideBarWhenSectionVisible(sectionId, resetKey) {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (!sectionId || typeof window === "undefined") {
      setHidden(false);
      return undefined;
    }

    let observer;
    let frame;
    let cancelled = false;

    const attach = () => {
      const el = document.getElementById(sectionId);
      if (!el) {
        setHidden(false);
        return;
      }

      observer = new IntersectionObserver(
        ([entry]) => {
          if (!cancelled) setHidden(Boolean(entry?.isIntersecting));
        },
        {
          threshold: 0,
          rootMargin: "-100px 0px -100px 0px",
        }
      );
      observer.observe(el);
    };

    frame = window.requestAnimationFrame(attach);

    return () => {
      cancelled = true;
      if (frame) window.cancelAnimationFrame(frame);
      observer?.disconnect();
    };
  }, [sectionId, resetKey]);

  return hidden;
}
